import { Typography } from 'antd'
import styled from 'styled-components'

import { weatherValues } from '../CustomBlocks/Weather/weatherConstants'

import { useLocale } from '@/context/localeContext'
import { WeatherDisplayBlock as WeatherDisplayBlockType } from '@/modules/templates/types/blueprint'

type Props = {
  block: WeatherDisplayBlockType
}

const SplitDisplay = styled.div`
  display: flex;
  flex-direction: row;
  width: fit-content;

  border: ${(props) => `1px solid ${props.theme.colour.secondary._400}`};
  border-radius: 10px;

  & > :not(:last-child) {
    border-right: ${(props) =>
      `1px solid ${props.theme.colour.secondary._400}`};
  }

  & > * {
    line-height: 40px;
    padding: 0 12px;
  }
`

export const WeatherDisplayBlock: React.FC<Props> = ({ block }) => {
  const { temperatureUnit } = useLocale()

  const weather = weatherValues.find((w) => w.value === block.value?.weather)

  if (!block.value?.temperature && !block.value?.weather) return null

  return (
    <SplitDisplay>
      <div>
        <span role="img" aria-label={weather?.label}>
          {weather?.icon}
        </span>
        &nbsp; {weather?.label}
      </div>
      <Typography.Text>
        {block.value?.temperature} {temperatureUnit}
      </Typography.Text>
    </SplitDisplay>
  )
}
